import { render, staticRenderFns } from "./LottoRate.vue?vue&type=template&id=e47734e2&"
import script from "./LottoRate.vue?vue&type=script&lang=js&"
export * from "./LottoRate.vue?vue&type=script&lang=js&"
import style0 from "./LottoRate.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports